// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1560":"css/admin-app.6989","8005":"css/app.6989"}[chunkId] + ".css";
};